import { render, staticRenderFns } from "./FundamentalLetter.vue?vue&type=template&id=af009994&"
import script from "./FundamentalLetter.vue?vue&type=script&lang=ts&"
export * from "./FundamentalLetter.vue?vue&type=script&lang=ts&"
import style0 from "./FundamentalLetter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports